// Roof rack products scraped from xpeditionz.co.nz

export const CONSTRUCTION_IMAGES = [
  {
    src: "/products/roofrack-proof/substructure-raw.webp",
    title: "Fully Welded Sub-Structure",
    caption: "Robust, all-alloy welded frame beneath the deck. Many mainstream racks — including Front Runner — have no separate sub-structure at all.",
    label: "01 · UNDERSIDE",
  },
  {
    src: "/products/roofrack-proof/corners-raw.webp",
    title: "All-Alloy Corners. No Plastic.",
    caption: "Fully welded alloy corners. Zero plastic structural components. Zero rivets in the load path. Built to survive genuine off-road abuse.",
    label: "02 · CORNER DETAIL",
  },
];

export const ROOF_HERO_IMAGES = {
  hero: "/products/roofracks/731077_b5cb33e4f3d34c16950bc13de2b2ab95~mv2.jpg",
  loadbars: "/products/roofracks/731077_4175814e40e548be93acce4014073832~mv2.jpg",
  loadbarsClose: "/products/roofracks/731077_29e4de121a8545dba30e2774ed7ba812~mv2.jpg",
  landcruiser: "/products/roofracks/731077_bfb4920d4add4bdca0426c4326202c2c~mv2.jpg",
};
